import { createBrowserClient } from '@supabase/ssr';
import type { Database } from '@repo-manager/db/types/supabase';

import { env } from './env';

export type SupabaseBrowserClient = ReturnType<typeof createSupabaseBrowserClient>;

function createSupabaseBrowserClient() {
  return createBrowserClient<Database>(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY);
}

/**
 * App-wide singleton, lazily instantiated. Hoisted out of the React tree
 * so React Router 7 loaders/actions (which run outside components) can
 * grab it directly without prop-drilling. `<SupabaseProvider>` consumes
 * the same instance.
 *
 * RLS is the security boundary — never embed a service-role key here.
 */
let _client: SupabaseBrowserClient | null = null;
export function getSupabase(): SupabaseBrowserClient {
  if (!_client) _client = createSupabaseBrowserClient();
  return _client;
}
